import React, { useState , useEffect} from "react";
import "./ModalDetail.css";
import { useCart } from "../CartProvider";
import { FaWhatsapp} from "react-icons/fa";

const formatFCFA = (n) =>
  new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Number(n || 0));

const ModalDetail = ({ isOpen, onClose , myProducts}) => {
    const [myImage , setMyImage] = useState(myProducts?.image);
    const { cart, addToCart, inc, dec } = useCart();

    const qty = cart[myProducts.id]?.qty ?? 0;
    const inCart = qty > 0;

    useEffect(() => {
         
    setMyImage(myProducts?.image);
        }, [myProducts]);

  if (!isOpen) return null;

  
  return (
    <div className="overlay-cmodal">
      <div className="modal-cmodal">
        {/* Bouton Fermer */}
        <button className="close-cmodal" onClick={onClose}>
          &times;
        </button>

        {/* Section image + vignettes */}
        <div className="left-cmodal">
          <div className="mainImage-cmodal">
            <img
              src={myImage}
              alt="SilkSkin Serum"
            />
          </div>
          <div className="thumbnails-cmodal">
  {myProducts?.Images.map((item, idx) => (
    <img 
      key={idx} 
      src={item} 
      alt={`thumb-${idx}`} 
      onClick={() => setMyImage(item)} 
    />
  ))}
</div>

        </div>

        {/* Section détails produit */}
        <div className="right-cmodal">
          <p className="category-cmodal"></p>
          <h2 className="title-cmodal">{myProducts.title}</h2>
          <p className="desc-cmodal">
            {myProducts?.Description}
          </p>
          <p className="stock-cmodal">{myProducts?.stock > 0 ? "✅ En Stock" : 'Ce produit est actuellement en rupture de stock et sera de retour d’ici un mois, mais vous pouvez le reserver spécialement en nous contactant sur WhatsApp.'}</p>

          <div className="price-cmodal">
            <span className="newPrice-cmodal">{formatFCFA(myProducts?.price)} FCFA</span>
            <span className="oldPrice-cmodal">...</span>
          </div>

          

          <div className="sizeSelector-cmodal">
            
          </div>

          {!inCart ? (
            myProducts?.stock > 0
                  ?
                  <div className="actions-cmodal">
            <button className="detail-addcart-detail" onClick={() => addToCart(myProducts.id , myProducts)}>Add To Cart</button>
            <button className="detail-addcart-detail" onClick={onClose}>Continuer le shopping</button>
          </div>
                  :
                  <div className="actions-cmodal">
            <a className="detail-addcart-detail"
            target="_blank"
                  rel="noreferrer"
             href="https://wa.me/+22890045926" style={{textDecoration:'none'}}><FaWhatsapp size={20} /> Whatsapp</a>
            <button className="detail-addcart-detail" onClick={onClose}>Continuer le shopping</button>
          </div>
            ) : (
        //         <div className="qty-ctrl-pl">
        //     <button onClick={() => dec(myProducts.id)}>-</button>
        //     <input type="number" disabled value={qty} />
        //     <button onClick={() => inc(myProducts.id, myProducts.stock)}>+</button>
        //   </div>

          <div className="qty-wrap-pl">
                      <span className="qty-label-pl" style={{fontWeight:'bold' , color:'black', marginRight: '30px'}}>Quantité: </span>
                      <div className="qty-ctrl-pl">
                        <button onClick={() => dec(myProducts.id)} aria-label="Decrease">−</button>
                        <span>{qty}</span>
                        <button onClick={() => inc(myProducts.id, myProducts.stock)} aria-label="Increase">+</button>
                      </div>
                    </div>
                )}

          <div className="subtotal-pl">
                      <span>Sous total: </span>
                      <strong >
                        {formatFCFA((qty * Number(myProducts.price)))} FCFA
                      </strong>
                    </div>

          

          {/* <p className="sku-cmodal">SKU: GRF85648HGJ</p>
          <p className="tags-cmodal">Tags: Skincare, Serums, Vitamin C</p> */}

          <div className="share-cmodal">
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDetail;
